var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"puzzle-img",style:(_vm.style),attrs:{"src":_vm.imagePath}})
}
var staticRenderFns = []

export { render, staticRenderFns }